import { useEffect } from "react";

// Lightweight document-head SEO manager (no external dependency).
export default function useSeo({ title, description, path }) {
  useEffect(() => {
    if (title) document.title = title;
    const set = (name, content, attr = "name") => {
      if (!content) return;
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    set("description", description);
    set("og:title", title, "property");
    set("og:description", description, "property");
    let canonical = document.querySelector('link[rel="canonical"]');
    if (canonical && path) {
      canonical.setAttribute("href", `https://www.emeraldcrown.co.uk${path}`);
    }
  }, [title, description, path]);
}
